import React from "react";
import Checkout3 from "../components/Checkout3";

const checkout3 = () => {
  return <Checkout3 />;
};

export default checkout3;
